import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import IconWrapper from '@segment/matcha/components/IconWrapper'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import data from './data'

type UnderTheHoodProps = {}

const copy = {
  heading: `Additional Resources`,
}

const UnderTheHood: FC<PropsWithChildren<UnderTheHoodProps>> = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <SectionBase variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h2" variant="h2">
              {copy.heading}
            </CopyText.Heading>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <AppearanceProvider appearance="twilioLight">
            <Body>
              <ColumnTrack columns={1} overrides={{ md: 2 }}>
                {data.map((card, index) => (
                  <CardBase key={index} href={getAbsoluteUrl(card.link.href, pageConfig)}>
                    <Card.Body>
                      <Card.Accessories>
                        <Card.AccessoriesRow>
                          <IconWrapper variant="transparent" elevation={0}>
                            {card.icon}
                          </IconWrapper>
                        </Card.AccessoriesRow>
                      </Card.Accessories>
                      <Card.Copy>
                        {card.title && <Card.Headline tag="h3">{card.title}</Card.Headline>}
                        <Card.Description variant="pLarge">{card.body}</Card.Description>
                      </Card.Copy>
                      <Card.Action alignment="right">
                        <ChevronRightIcon />
                      </Card.Action>
                    </Card.Body>
                  </CardBase>
                ))}
              </ColumnTrack>
            </Body>
          </AppearanceProvider>
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.article`
  overflow: auto;
`

const Body = styled.div`
  max-width: 960px;
  margin: 0 auto;
`

export default UnderTheHood
